import { ArrowDownIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { AbilityText } from "../../components/AbilityText/AbilityText";
import { ErrataSerialDictionary, VariantErrata } from "../../models/Errata";
import { CardVariant } from "../../models/CardVariant";
import { CardVariantImage } from "../../components/CardVariantImage/CardVariantImage";
import { classNames, classNamesOrEmpty } from "../../style/common";

const errataTypeMap = {
    "abilityText": "Effect Text",
    "name": "Name",
    "job": "Job"
}

export type ErrataComponentProps = {
    errataDictionary: ErrataSerialDictionary,
    cardVariantsBaseBySerialDictionary: Record<string, CardVariant>,
    classNames?: {
        container?: string | undefined,
        textContainer?: string | undefined
    }
}

export function ErrataComponent(props: ErrataComponentProps) {
    return (
        <div className={`space-y-14 max-w-7xl ${classNamesOrEmpty(props.classNames?.container)}`}>
            {
                Object.entries(props.errataDictionary).map(([serial, errata]) => {
                    const matchingCard = props.cardVariantsBaseBySerialDictionary[serial];

                    if (!matchingCard) {
                        console.warn(`Could not find card for errata ${serial}`, errata);
                        return <></>
                    }

                    return <SingleCardErrata key={`errata-${serial}`} variantErrata={{ ...matchingCard, errata }} classNames={props.classNames} />
                })
            }
        </div>
    )
}

export type SingleCardErrataProps = {
    variantErrata: VariantErrata,
    classNames?: {
        container?: string | undefined,
        textContainer?: string | undefined
    }
}

export function SingleCardErrata(props: SingleCardErrataProps) {
    return (
        <div>
            <h2 className="text-lg font-semibold mb-1">{props.variantErrata.serial}</h2>
            <div className="grid grid-cols-1 md:grid-cols-[300px_auto] gap-6">
                <div className="max-w-[300px] m-auto md:m-0">
                    <CardVariantImage variant={props.variantErrata} />
                </div>
                <div className="flex flex-col xl:flex-row">
                    <div className={classNames("md:flex-1 p-4 rounded-xl border bg-secondary border-color-border shadow items-start flex flex-col space-y-8", props.classNames?.textContainer)}>
                        {
                            props.variantErrata.errata.map((item) => {
                                return (
                                    <div key={`${props.variantErrata.serial}-${item.type}`}>
                                        <p className="font-semibold">{errataTypeMap[item.type]}</p>
                                        <AbilityText abilityText={item.original} />
                                        <a href={item.source} target="_blank" className="block mt-3 font-semibold text-blue-600 text-sm">source</a>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="flex items-center justify-center">
                        <span className="hidden xl:block"><ArrowRightIcon className="h-8 w-8 text-blue-600" /></span>
                        <span className="block xl:hidden"><ArrowDownIcon className="h-8 w-8 text-blue-600" /></span>
                    </div>
                    <div className={classNames("md:flex-1 p-4 rounded-xl border border-color-border bg-secondary shadow items-start flex flex-col space-y-8", props.classNames?.textContainer)}>
                        {
                            props.variantErrata.errata.map((item) => {
                                return (
                                    <div key={`${props.variantErrata.serial}-${item.type}`}>
                                        <p className="font-semibold">{errataTypeMap[item.type]}</p>
                                        <AbilityText abilityText={item.errata} />
                                        <a href={item.source} target="_blank" className="block mt-3 font-semibold text-blue-600 text-sm">source</a>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

